// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';

// ── CSS Architecture ─────────────────────────────────────
// globals.css is the single entry point — it imports:
//   theme.css            → All CSS variables (dark + light mode)
//   global.css           → Base styles, layout helpers, utilities
//   components.css       → Reusable component styles
//   dark-enhancements.css → Aurora, glass2, neon borders, stars
// To change the entire theme: edit src/styles/theme.css only.
import './styles/globals.css';

import App from './app/App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

